var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOwners = function SvgOwners(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M27.5 0a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15m-4.167 7.5a4.167 4.167 0 1 1 8.333 0 4.167 4.167 0 0 1-8.333 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 16.667c-7.35 0-11.667 5.89-11.667 11.666h3.333c0-4.224 3.1-8.333 8.334-8.333 5.233 0 8.333 4.11 8.333 8.333h3.333c0-5.776-4.316-11.666-11.666-11.666M.833 30c0-5.632 3.881-11.667 10.833-11.667 1.662 0 3.182.356 4.527.995l-1.43 3.01c-.89-.422-1.92-.671-3.097-.671-4.582 0-7.5 3.965-7.5 8.333z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.666 3.333a6.667 6.667 0 1 0 0 13.334 6.667 6.667 0 0 0 0-13.334M8.333 10A3.333 3.333 0 1 1 15 10a3.333 3.333 0 0 1-6.667 0",
    clipRule: "evenodd"
  })));
};
export default SvgOwners;